import * as Yup from 'yup'

const blockUserValidator = Yup.object ({
  comment: Yup
    .string ()
    .required ('Insira o motivo do bloqueio')
    .max (512, 'O motivo deve conter até 512 caracteres'),
})

export default blockUserValidator
